"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedList = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const reactstrap_1 = require("reactstrap");
const react_router_dom_1 = require("react-router-dom");
const classnames_1 = require("classnames");
class SelectedList extends React.Component {
    render() {
        const { tagStore, type, complete, codes } = this.props;
        if (!tagStore) {
            return null;
        }
        return (React.createElement("div", { className: "tag-selected-list" },
            tagStore.groups.map((group, gi) => {
                return tagStore.getFilteredTags({
                    group: group,
                    type: type,
                    selected: complete ? undefined : true,
                    codes: codes
                }).map((tag, ti) => {
                    const query = tagStore.getQuery(tag.code);
                    return (React.createElement(react_router_dom_1.Link, { to: query ? `?q=${query}` : '#', key: `${gi}.${ti}` },
                        React.createElement(reactstrap_1.Badge, { className: classnames_1.default('mx-1', 'tag', 'tag-group', 'tag-group-' + group.color, { 'tag-selected': tag.selected }), pill: true },
                            React.createElement("i", { className: " mdi mdi-pound" }),
                            tag.label,
                            !complete && (React.createElement("i", { className: "mdi mdi-close ml-2" })))));
                });
            }),
            tagStore.nbSelected > 0 && (React.createElement(react_router_dom_1.Link, { to: "#" },
                React.createElement(reactstrap_1.Badge, { className: classnames_1.default('mx-1', 'tag', 'tag-group', 'tag-trash'), pill: true },
                    React.createElement("i", { className: " mdi mdi-trash-can-outline" }))))));
    }
}
exports.SelectedList = SelectedList;
exports.default = mobx_react_1.inject('tagStore')(mobx_react_1.observer(SelectedList));
